import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import SubscriptionCharges from '../containers/SubscriptionCharges';
import SubscriptionInvoices from '../containers/SubscriptionInvoices';
import SubscriptionDetails from './SubscriptionDetails';
import BrandSubscriptionOptions from '../../brands/containers/BrandSubscriptionOptions';
import SubscriptionForm from '../containers/SubscriptionForm';
import Tabs from '../../shops/components/ShopListTabs';

const Subscription = ({ subscription, saveSubscription, subscriptionPlans, brandId }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <SubscriptionDetails subscription={subscription} />
        <div className="c-separator u-mv--" />
        <BrandSubscriptionOptions brandId={brandId} />
        <div className="c-separator u-mv" />
        <div>
          <SubscriptionForm
            onSubmit={saveSubscription}
            subscription={subscription}
            subscriptionPlans={subscriptionPlans}
          />
        </div>
        <div>
          <Tabs display-if={subscription}>
            <div label={t('subscription:one_time_charges_tab')}>
              <SubscriptionCharges currency={subscription && subscription.currency} />
            </div>
            <div label={t('subscription:invoices_tab')}>
              <SubscriptionInvoices currency={subscription && subscription.currency} />
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
);

Subscription.propTypes = {
  subscription: PropTypes.object,
  saveSubscription: PropTypes.func.isRequired,
  subscriptionPlans: PropTypes.arrayOf(PropTypes.object),
  brandId: PropTypes.string,
};

Subscription.defaultProps = {
  subscription: null,
  subscriptionPlans: [],
  brandId: null,
};

export default Subscription;

